import './BackSquid.styles.css'

export default function BackSquid() {
    return (
        <img id="back-squid" src="/android-chrome-512x512.png" alt="background" />
    )
}
